import React, { useEffect, useState } from 'react';
import Alerts from './Alerts';
import { monitoringAlertInternalApi } from '../../apis';
import { InternalApiMonitoringAlert } from '../../api-internal';

interface AlertProps {
  transactionId: string;
  personId: string;
}

export const TransactionAlerts = ({ transactionId, personId }: AlertProps) => {
  const [fetching, setFetching] = useState(false);
  const [alerts, setAlerts] = useState<InternalApiMonitoringAlert[]>();

  const fetchAlerts = (id: string) => {
    monitoringAlertInternalApi.findMonitoringAlertsByTransactionId({ transactionId: id }).then((alerts) => {
      setFetching(false);
      setAlerts(alerts);
    });
  };

  useEffect(() => {
    fetchAlerts(transactionId);
  }, [transactionId]);

  return (
    <Alerts
      personId={personId}
      page={0}
      size={alerts?.length || 0}
      total={alerts?.length || 0}
      loading={fetching}
      alerts={alerts || []}
      attributes={[
        { key: 'ID', sortable: true },
        { key: 'Date', sortable: true },
        { key: 'Details', sortable: true },
        { key: 'Assignee', sortable: true },
        { key: 'Status', sortable: true },
        { key: 'Actions', sortable: true },
      ]}
      onUpdate={() => fetchAlerts(transactionId)}
    />
  );
};

export default TransactionAlerts;
